// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2NDO_","label":"Labeled_label__wsAiQ","divider":"Labeled_divider__hWu_I"};